import React from "react";

const Manuals = props => (
  <svg viewBox="0 0 23 19" fill="none" {...props}>
    <path
      d="M20.328.75c-.937.04-5.625.352-8.555 1.914a.762.762 0 01-.585 0C8.258 1.102 3.57.79 2.633.75 1.305.75.25 1.805.25 3.094v11.562c0 1.25.977 2.227 2.227 2.305 1.367.078 4.765.312 7.109 1.172.234.078.43.117.625.117h2.5c.234 0 .43-.04.664-.117 2.344-.86 5.742-1.094 7.11-1.172 1.25-.078 2.226-1.055 2.226-2.305V3.094C22.75 1.804 21.656.75 20.328.75zm-9.453 15.664a.642.642 0 01-.625.625c-.078 0-.117-.039-.195-.039-2.461-.938-5.82-1.21-7.5-1.29-.586-.038-1.055-.468-1.055-1.054V3.094c0-.586.508-1.055 1.133-1.055.742 0 4.765.273 7.5 1.484.43.196.703.625.703 1.094l.039 3.906v7.891zM21.5 14.656c0 .586-.508 1.016-1.094 1.055-1.68.078-5.039.351-7.5 1.289-.078 0-.117.04-.195.04a.642.642 0 01-.625-.626v-7.89l.039-3.907c0-.469.273-.898.703-1.094 2.735-1.21 6.758-1.484 7.5-1.484.625 0 1.133.469 1.133 1.055v11.562h.039z"
      fill="currentColor"
      fillOpacity={0.3}
    />
  </svg>
);

export default Manuals;
